import { render, staticRenderFns } from "./DomainList.vue?vue&type=template&id=2f966030"
import script from "./DomainList.vue?vue&type=script&lang=js"
export * from "./DomainList.vue?vue&type=script&lang=js"
import style0 from "./DomainList.vue?vue&type=style&index=0&id=2f966030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports